import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import { CurrencyDisplay } from "./PriceTypes";
import PriceTerms from "./components/PriceTerms";

var Price = function Price(_ref) {
  var currencyDisplay = _ref.currencyDisplay,
      currency = _ref.currency,
      price = _ref.price,
      lang = _ref.lang,
      period = _ref.period,
      separator = _ref.separator;
  var getClassName = getClassNameFactory(Price.displayName);
  var options = {
    style: "currency",
    currencyDisplay: currencyDisplay,
    currency: currency
  };
  var numberFormat = new Intl.NumberFormat(lang, options);
  var priceWithCurrency = numberFormat.format(price);
  return /*#__PURE__*/React.createElement("span", {
    className: getClassName(),
    lang: lang
  }, priceWithCurrency, /*#__PURE__*/React.createElement(PriceTerms, {
    period: period,
    separator: separator
  }));
};

Price.displayName = "Price";
Price.defaultProps = {
  currency: "USD",
  lang: "en-US",
  currencyDisplay: CurrencyDisplay.SYMBOL
};
export default Price;